import { Box, Skeleton } from '@mui/material';
import React from 'react';

const SelfAssessmentSkeletonLoader = () => {
  return (
    <div className="margin-top--md">
      <Box padding={1}>
        <Box display="flex" marginTop={2}>
          <Box flex={1}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={120}
              style={{ borderRadius: '5px' }}
            />
          </Box>

          <Box marginLeft={2} flex={1}>
            <Skeleton width="90%" height={30} />
            <Skeleton width="90%" height={30} />
            <Skeleton width="90%" height={30} />
            <Skeleton width="90%" height={30} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default SelfAssessmentSkeletonLoader;
